import { useState } from 'react';
import { toast } from 'sonner';
import { UI } from '@/lib/constants';
import { validateStep } from '@/lib/assessmentValidation';

/**
 * Step navigation + validation. Decoupled from form state so it can be
 * unit-tested in isolation. Returns a fully-composed navigation API.
 */
export function useStepNavigation(state) {
  const [step, setStep] = useState(1);
  const [stepError, setStepError] = useState(null);
  const totalSteps = UI.ASSESSMENT_TOTAL_STEPS;

  const clearError = () => setStepError(null);

  const validateOrToast = () => {
    const err = validateStep(step, state);
    if (err) { setStepError(err); toast.error(err); }
    return err;
  };

  const goNext = () => {
    if (validateOrToast()) return;
    clearError();
    if (step < totalSteps) setStep(step + 1);
  };

  const goPrevious = () => { clearError(); if (step > 1) setStep(step - 1); };

  return { step, totalSteps, stepError, clearError, validateOrToast, goNext, goPrevious };
}
